import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Wraps every case-insensitive occurrence of `search` inside `value` with
 * <mark>...</mark> so it can be bound via [innerHTML] in a table cell.
 *
 * Usage:  <td [innerHTML]="row.name | highlight:searchTerm"></td>
 * for Search
 */

@Pipe({
  name: 'highlight'
})

export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: unknown, search: string | null | undefined): SafeHtml {
    const text = value == null ? '' : String(value);

    if (!search || !search.trim()) {
      return this.sanitizer.bypassSecurityTrustHtml(this.escapeHtml(text));
    }

    const escapedText = this.escapeHtml(text);
    const escapedSearch = this.escapeRegExp(search.trim());
    const regex = new RegExp(`(${escapedSearch})`, 'gi');
    const highlighted = escapedText.replace(regex, '<mark class="cell-hit">$1</mark>');

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }

  // Escape the search term so characters like ( ) . * + ? don't break the regex.
  private escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Escape the cell's own text so it can't inject markup via [innerHTML].
  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}